<template>
  <div>
    <div class="search">
      <div class="left flex1">
        <el-form label-width="102px" :mode="queryControl" label-suffix=":">
          <div class="form-box">
            <el-form-item label="年份" class="formItem">
              <el-date-picker v-model="queryControl.year" :editable="false" :clearable="false" value-format="yyyy" placeholder="请选择月份" type="year" @change="changeYear" />
            </el-form-item>
            <!-- <el-form-item label="月份">
              <el-date-picker
                v-model="queryControl.month"
                :editable="false"
                :picker-options="pickerOptionMonth"
                :clearable="true"
                placeholder="请选择月份"
                style="width: 150px;"
                type="month"
                @change="query"
              />
            </el-form-item> -->
            <el-form-item class="formItem" label="发起类型" prop="type">
              <el-select v-model="queryControl.type" placeholder="请选择" @change="query()">
                <el-option label="全部" :value="''" />
                <el-option label="平台主动发起" :value="1" />
                <el-option label="客户主动发起" :value="2" />
              </el-select>
            </el-form-item>
            <template v-if="showMoreSearch">
              <el-form-item class="formItem" label="发起时间">
                <el-date-picker
                  v-model="queryControl.query_date"
                  type="daterange"
                  range-separator="~"
                  start-placeholder="开始日期"
                  :clearable="true"
                  end-placeholder="结束日期"
                  :editable="false"
                  :value-format="'yyyy-MM-dd'"
                  unlink-panels
                  :picker-options="pickerOptions"
                  @change="query()"
                />
              </el-form-item>
              <el-form-item class="formItem" label="签署完成时间">
                <el-date-picker
                  v-model="queryControl.time"
                  type="daterange"
                  range-separator="~"
                  start-placeholder="开始日期"
                  :clearable="true"
                  end-placeholder="结束日期"
                  :editable="false"
                  :value-format="'yyyy-MM-dd'"
                  unlink-panels
                  :picker-options="pickerOptions"
                  @change="query()"
                />
              </el-form-item>
            </template>
            <div class="formItem operate">
              <div>
                <el-button type="primary" @click="query">查询</el-button>
                <el-button @click="resetForm">重置</el-button>
              </div>
              <div class="more ml10 pointer" @click="showMoreSearch = !showMoreSearch">
                <i :class="showMoreSearch ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" />
                <span class="ml5">{{ showMoreSearch ? '收起' : '展开' }}</span>
              </div>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <div class="total_box mb22">
      <span>已对账总金额：<span class="active_color">￥{{ $formatCurrency(total) }}</span></span>
    </div>
    <zf-table
      :columns="column"
      :data-source="tableData"
      :pagination="false"
    >
      <!-- 月份 -->
      <template
        slot="month"
        slot-scope="{ row }"
      >
        <span>{{ row.month }}</span>
      </template>
      <!-- 消耗金额 -->
      <template
        slot="work_price"
        slot-scope="{ row }"
      >
        ￥{{ $formatCurrency(row.work_price) }}
      </template>
      <!-- 支付宝金额 -->
      <template
        slot="zfb_price"
        slot-scope="{ row }"
      >
        ￥{{ $formatCurrency(row.zfb_price) }}
      </template>
      <!-- 微信金额 -->
      <template
        slot="wx_price"
        slot-scope="{ row }"
      >
        ￥{{ $formatCurrency(row.wx_price) }}
      </template>
      <!-- 服务费率 -->
      <template
        slot="rate"
        slot-scope="{ row }"
      >
        {{ row.rate }}%
      </template>
      <!-- 服务费 -->
      <template
        slot="service_price"
        slot-scope="{ row }"
      >
        ￥{{ $formatCurrency(row.service_price) }}
      </template>
      <!-- 对账金额 -->
      <template
        slot="rcon_price"
        slot-scope="{ row }"
      >
        ￥{{ $formatCurrency(row.rcon_price) }}
      </template>
      <!-- 对账周期 -->
      <template
        slot="start_day"
        slot-scope="{ row }"
      >
        {{ row.start_day }} ~ {{ row.end_day }}
      </template>
      <!-- 发起时间 -->
      <template
        slot="send_time"
        slot-scope="{ row }"
      >
        {{ row.send_time }}
      </template>
      <!-- 签署完成时间 -->
      <template
        slot="confirm_time"
        slot-scope="{ row }"
      >
        <span>{{ row.confirm_time }}</span>
      </template>
      <!-- 发起类型 -->
      <template
        slot="type"
        slot-scope="{ row }"
      >
        {{ row.type == 1 ? '平台发起' : '客户发起' }}
      </template>
      <!-- 操作 -->
      <template
        slot="action"
        slot-scope="{ row }"
      >
        <a v-if="powerReg('0198e80f51469b7617c841eeddfe376d')" class="active_color" @click="openView(row)">查看对账单</a>
      </template>
    </zf-table>
    <!-- <noData v-else /> -->
  </div>
</template>

<script>
import column from '../columns/haveCheck'
// import noData from '@/components/noData'
import dayJs from 'dayjs'
import ZfTable from '@/components/ZfTable/CoreTable'
import { overInvoice } from '@/api/invoice'
export default {
  name: 'HaveCheck',
  components: {
    ZfTable
  },
  data() {
    const that = this
    return {
      column,
      queryControl: {
        // month: dayJs().format('YYYY-MM'),
        month: '',
        type: '',
        query_date: [],
        time: [],
        year: dayJs().format('YYYY')
      },
      pickerOptionMonth: {
        disabledDate(time) {
          const curYearTime = new Date(`${that.queryControl.year}`).getTime()
          const nextYearTime = new Date(`${+that.queryControl.year + 1}`).getTime()
          const curTime = time.getTime()
          if (curYearTime <= Date.now() && Date.now() < nextYearTime) {
            return curTime < curYearTime || curTime > Date.now()
          } else {
            return curTime < curYearTime || curTime > nextYearTime - 1 * 24 * 60 * 60 * 1000
          }
        }
      },
      tableData: [],
      pageControl: {
        pageNumber: 1,
        pageSize: 10,
        total: 0
      },
      total: '',
      showMoreSearch: true
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    resetForm() {
      this.queryControl = {
        // month: dayJs().format('YYYY-MM'),
        type: '',
        query_date: [],
        time: [],
        year: dayJs().format('YYYY')
      }
      this.query()
    },
    async query() {
      const data = await overInvoice({
        year: this.queryControl.year,
        send_time_start: this.queryControl.query_date && this.queryControl.query_date.length ? this.queryControl.query_date[0] : '',
        send_time_end: this.queryControl.query_date && this.queryControl.query_date.length ? this.queryControl.query_date[1] : '',
        confirm_time_start: this.queryControl.time && this.queryControl.time.length ? this.queryControl.time[0] : '',
        confirm_time_end: this.queryControl.time && this.queryControl.time.length ? this.queryControl.time[1] : '',
        month: this.$dayFormat(this.queryControl.month, 2),
        type: this.queryControl.type
      })
      if (data.code === 200) {
        this.tableData = data.data.list
        this.total = data.data.over_all_price
      }
    },
    openView(row) {
      // 发起结算单
      if (!row.esign_url) {
        this.$message.error('暂未签署完成')
        return
      }
      window.open(row.esign_url)
    },
    changeYear(val) {
      // this.queryControl.month = val
      this.query()
    }
  }
}
</script>

<style lang="scss" scoped>

</style>

